export default __webpack_public_path__ + "static/media/inventory.34a97c5f.svg";